import { render, staticRenderFns } from "./CrmMarketing.vue?vue&type=template&id=22314f9b&scoped=true"
import script from "./CrmMarketing.vue?vue&type=script&lang=js"
export * from "./CrmMarketing.vue?vue&type=script&lang=js"
import style0 from "./CrmMarketing.vue?vue&type=style&index=0&id=22314f9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22314f9b",
  null
  
)

export default component.exports